<template>
<div :class="show_poster || show_comment ? 'page_historyDetail limited' : 'page_historyDetail'" :style="info.thumb? 'padding-bottom:3rem': 'padding-bottom: 1.5rem'">
    <div class="info">
        <div class="title">{{ info.title }}</div>
        <!-- <div class="images">
            <van-swipe :loop="false">
                <van-swipe-item class="image" v-for="(img,index) in info.imagesArr" :key="index">
                    <van-image fit="cover" :src="img" class="tu" />
                </van-swipe-item>
            </van-swipe>
        </div> -->
        <div class="jieshao" v-html="info.content"></div>
    </div>
    <!-- 发评论 点赞 -->
    <div class="bottom">
        <!-- 发评论 -->
        <!-- <div class="comment">
            <div class="comment_l">
                <van-field :border="false" v-model="comment_text" placeholder="说点什么吧～" />
            </div>
            <div class="comment_r" @click="toComent">发送</div>
        </div> -->
        <div class="icons">
            <!-- 展开评论 -->
            <div class="icon back">
                <div class="icon share" @click="showCommentFun">
                    <img :src="publicPath +'statics/images/yuekan/icon_zixun.png'" alt="">
                    <div class="nums" v-if="info.comment_num">{{ info.comment_num }}</div>
                </div>
                <div class="icon title">评论</div>
            </div>
            <!-- 点赞 -->
            <!-- <div class="icon back">
                <div class="icon like" @click="likeFun">
                    <img :src="info.is_like ? publicPath+'statics/images/icon_liked_red.png' : publicPath+'statics/images/icon_like.png' " alt="">
                    <div class="nums" v-if="info.like_num">{{info.like_num}}</div>
                </div>
                <div class="icon title">点赞</div>
            </div> -->
            <!-- 送花 -->
            <div v-for="daoju in allDaoJu" :key="daoju.id" class="icon back">
                <div class="icon share" @click="sendFlower(daoju)">
                    <img :src="daoju.thumb?imageUrl+daoju.thumb:(publicPath +'statics/images/icon_send_flower.png')" alt="">
                    <div class="nums" v-if="daoju.daoJuNum">{{ daoju.daoJuNum }}</div>
                </div>
                <div class="icon title">{{daoju.title}}</div>
            </div>
            <!-- 发起活动 -->
            <div class="icon back">
                <div class="icon share" @click="clickToPublish">
                    <img :src="publicPath +'statics/images/icon_publish.png'" alt="">
                    <!-- <div class="nums" v-if="info.share_num">{{ info.share_num }}</div> -->
                </div>
                <div class="icon title">发起活动</div>
            </div>
            <!-- 转发海报 -->
            <div class="icon back" v-if="info.thumb">
                <div class="icon share" @click="clickShareIcon">
                    <img :src="publicPath +'statics/images/icon_share_new.png'" alt="">
                    <div class="nums" v-if="info.share_num">{{ info.share_num }}</div>
                </div>
                <div class="icon title">转发海报</div>
            </div>
            
        </div>
    </div>
	<!-- 分享海报按钮 -->
	<div class="poster_btn" @click="showPosterFun" v-if="info.thumb"></div>
    <!-- 评论区域 -->
    <div class="section_comment" v-if="show_comment">
        <div class="close" @click="show_comment = false">
            <van-icon name="cross" />
        </div>
        <div class="history_comment">
            <div class="history_comment_l">
                <van-field :border="false" v-model="comment_text" placeholder="说点什么吧～" />
            </div>
            <div class="history_comment_r" @click="toComent">发送</div>
        </div>
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" :immediate-check="false" @load="getCommentsData">
            <div class="page_iteminfo">
                <div class="comment">
                    <div class="con" v-for="(item,index) in commentList" :key="index">
                        <div class="con_top clearfix">
                            <div class="f-l thumb">
                                <img :src="item.userthumb ? ($publicData.withHttpStart(item.userthumb) ? item.userthumb : imageUrl+item.userthumb) : $publicData.defaultTouxiang" alt="" class="thumb" />
                            </div>
                            <div class="f-l con_top_r">
                                <span class="user_name">{{ $publicData.formatPhone(item.username)}}</span>
                                <span class="time">{{ item.created_at }}</span>
                            </div>
                        </div>
                        <div class="con_nr">
                            <div class="yiji_txt">{{ item.comment }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </van-list>
    </div>
    <!-- 遮罩 -->
    <van-overlay :show="show_comment" @click="show_comment = false" />
    <!-- 海报遮罩 -->
    <van-overlay :show="show_poster" class="posterOverlay" @click="closePosterFun" />
    <!-- 发送道具特效 -->
    <van-overlay :show="showGif" @click="showGif = false" >
        <div v-if="showGif" class="gifback">
            <div class="gifimage">
                <van-image class="vanImage" fit="contain" :show-error="false" :show-loading="false" :src="imageUrl+gifUrl" />
            </div>
        </div>
    </van-overlay>
	<!-- 海报 -->
	<div class="poster" v-if="show_poster">
		<img :src="imageUrl+posterUrl" alt="" class="posterTu">
	</div>
	<div class="save" v-if="show_poster">长按保存图片</div>
</div>
</template>

<script>
import router from '../../../.././router'
import {
    LOGOUT,
    LOGIN
} from '../../../.././vuex/mutation_types'
import Vue from "vue";
import Bridge from "../../../.././vuex/bridge.js";

Vue.prototype.$bridge = Bridge;
var userAgent = navigator.userAgent;

export default {
    name: 'tohistory-index',
    data() {
        return {
			richImageUrl:this.$publicData.richTextImage,
			imageUrl: this.$publicData.uploadImage,
            publicPath: process.env.BASE_URL,
            token: '',
            history_id: this.$route.query.history_id,
            comment_text: null,
            show_comment: false,
            info: {}, // 详情数据
            commentList: [], // 评论列表
            pages: {
                page: 1,
                size: 10
            },
            loading: true,
            finished: false,
            show_poster: false, // 海报遮罩
            posterUrl: null, // 海报img地址
            allDaoJu : null, //所有的道具
            showGif: false, //播放gif
            gifUrl: null,
            sending: false,
            shareConfig: null, // 分享的相关配置
            sendLoading: false,
            clickTimes: 0,
            timeOut: null
        }
    },
    created: function () {
        console.log('history_id', this.history_id)
        var that = this
        //根据userAgent判断是否在iOSAndroid客户端中，隐藏原生导航栏
        if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
            var params = {
                data: {
                    'naviTitle': '历史记忆详情',
                    'rightStyle': 'share'
                }
            };
            this.$bridge.callhandler("sdjy://navigation/style", params, (data) => {});
            //获取用户信息
            var memberParams = {
                data: {
                    notCallLogin: 1,
                },
            };
            this.$bridge.callhandler("sdjy://member/memberInfo", memberParams,
                (data) => {
                    if (data.code == 200) {
                        this.token = data.result.token;
                        this.getData(1)
						this.getCommentsData()
                    } else {
                        this.token = "";
                    }
                }
            );
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler(
                "sdjy://common/refreshPage",
                (data, responseCallback) => {
                    // alert(JSON.stringify(data));
                    responseCallback('');
                }
            );
            this.$bridge.registerhandler('sdjy://common/rightButtonAction', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                console.log('sdjy://common/rightButtonAction')
                var imgUrl = that.$publicData.domain + that.$publicData.logo // 分享图标
                if (that.info.thumb) {
                    imgUrl = that.$publicData.domain + that.info.thumb
                }
                if (that.info.history_id == '185') {
                    imgUrl = that.$publicData.domain + '/upload/20200731/20200731095221478.jpeg'
                }
                const url = location.href.split('#')[0];
                var params = {
                    data: {
                        title: that.info.title ? that.info.title : that.$publicData.shareDefaultTitleA,
                        detail: that.info.describe?that.info.describe:that.info.title,
                        url: url,
                        platFormType:'',
                        image: imgUrl ? imgUrl : that.$publicData.domain + that.$publicData.shareDefaultIcon
                    },
                };
                this.$bridge.callhandler('sdjy://public/share', params, (data) => {

                })

            })
        } else {
            this.token = this.$store.getters.token;
            this.getData(1)
			this.getCommentsData()
        }
        
    },
    methods: {
        // 获取详情信息
        getData(init) {
			var that = this;
            var times = this.clickTimes;
            var params = {
                token: this.token,
                history_id: this.history_id
            }
            this.$api.history.hisotryInfo(params).then(res => {
                if (res.code == 200) {
                    if (times != this.clickTimes) {
                        return
                    }
                    var info = res.result
                    // 多张封面图
                    // if (info.thumb) {
                    //     info.imagesArr = info.thumb.split(',')
                    // }
                    if (info.daoju && info.daoju.length > 0) {
						var allDaoJu = info.daoju
						for(var j in allDaoJu){
							if(allDaoJu[j].daoju_user_count){
								var daoJuNum = allDaoJu[j].daoju_user_count
								allDaoJu[j].daoJuNum = daoJuNum.toString().length > 4 ? '···' : daoJuNum
							}
						}
						this.allDaoJu = info.daoju
						console.log('this.allDaoJu',this.allDaoJu)
                    }
                    // 评论数 点赞数 大于2个字符显示··· 小于2个字符正常显示
                    info.comment_num = (info.num.comment_num).toString().length > 4 ? '···' : info.num.comment_num
					info.like_num = (info.num.like_num).toString().length > 4 ? '···' : info.num.like_num
					// 分享数
					if(info.num.share_num){
						info.share_num = (info.num.share_num).toString().length > 4 ? '···' : info.num.share_num
					};
					// 处理富文本
					info.content = info.content.replace(/(<img [^>]*src=['"])([^'"]+)([^>]*)/g,function(match,$1,$2,$3){
						if(/^http/.test($2)){
							return $1 + $2 + $3;
						}else{
							return $1 + that.richImageUrl +$2 + $3;
						}
					});
					this.info = info
					// 第一次初始化页面时,调分享, 更新页面信息时,不再调
					if(init){
						this.getShareData()
					}
                    
                }
            })
        },
        // 获取评论列表
        getCommentsData() {
            var params = {
                token: this.token,
                page: this.pages.page,
                size: this.pages.size,
                history_id: this.history_id
            }
            this.$api.history.commentList(params).then(res => {
                if (res.code == 200) {
                    var list = res.result.list.comment
                    if (list) {
                        for (var i in list) {
                            this.commentList.push(list[i])
						}
						this.pages.page++
                		this.loading = false
                    } else {
                        this.finished = true
                    }
                } else {
                    this.finished = true
                }
            })
        },
        // 点赞
        likeFun() {
            var params = {
                token: this.token,
                history_id: this.history_id
            }
            var liked_status = this.info.is_like
            this.$api.history.like(params).then(res => {
                if (res.code == 200) {
                    if (!liked_status) {
                        this.$toast('点赞成功')
                    } else {
                        this.$toast('取消点赞')
                    }
                    this.getData()
                }
            })
        },
        // 添加评论
        toComent() {
            if (!this.comment_text) {
                this.$toast('请填写评论内容')
                return
            }
            if (this.sendLoading) {
                return
            }
            this.sendLoading = true
            var params = {
                token: this.token,
                history_id: this.history_id,
                comment: this.comment_text,
                type: 1 // 1评论,2回复评论 ,目前无二级评论
            }
            this.$api.history.createComment(params).then(res => {
                this.sendLoading = false
                if (res.code == 200) {
                    this.$toast('评论成功')
                    this.comment_text = ''
                    this.pages.page = 1
                    this.commentList = []
                    this.getData()
                    this.getCommentsData()
                }
            })

        },
        // 展开评论
        showCommentFun() {
            this.show_comment = true
        },
        sendFlower(daoju) {
            // if (this.showGif) {
            //     return
            // }
            // if (this.sending) {
            //     return
            // }
            this.sending = true
            var that = this;
            var params = {
                token: this.token,
                history_id: this.history_id,
                daoju_id: daoju.id,
            }
            this.$api.history.sendFlower(params).then(res => {
                this.sending = false
                if (res.code == 200) {
                    // this.$toast('发送道具成功')
                    that.gifUrl = daoju.file
                    if (that.gifUrl != null && that.gifUrl != undefined && that.gifUrl != '') {
                        that.clickTimes ++ 
                        daoju.daoJuNum ++
                        that.getData()
                        that.showGif = true
                        if (that.timeOut) {
                            clearTimeout(that.timeOut)
                        }
                        that.timeOut = setTimeout(function(){
                            that.showGif = false
                        },6150)
                    } else {
                        this.$toast('发送'+daoju.title+'成功')
                    }
                    
                } else {
                    this.$toast(res.message)
                }
            })
		},
		// 展示海报
		showPosterFun(){
			var params = {
				token: this.token,
                history_id: this.history_id
			}
			this.$api.history.sharePoster(params).then(res=>{
				if(res.code == 200){
					this.show_poster = true
					this.posterUrl = res.result
				}
			})			
		},
		// 关闭海报
		closePosterFun(){
			this.show_poster = false
			this.getData()
        },
        // 获取分享参数 -- 用于配微信分享
        getShareData() {
            const url = location.href.split('#')[0];
            console.log('url', url)
            this.$api.index.commonShare({
                url: url
            }).then(res => {
                if (res.code == 200) {
                    this.shareConfig = res.result
                    // console.log('this.shareConfig', this.shareConfig)
                    // console.log('this.$route', this.$route)
                    this.shareFun()
                }
            })
        },
        // 分享
        shareFun() {
            var that = this
            var imgUrl = that.$publicData.domain + that.$publicData.logo // 分享图标
            if (that.info.thumb) {
                imgUrl = that.imageUrl + that.info.thumb
            }
            if (that.info.history_id == '185') {
                imgUrl = that.$publicData.domain + '/upload/20200731/20200731095221478.jpeg'
            }
            console.log('imageurl',imgUrl)
            wx.config({
                debug: that.shareConfig.debug,
                beta: that.shareConfig.beta,
                jsApiList: that.shareConfig.jsApiList,
                appId: that.shareConfig.appId,
                nonceStr: that.shareConfig.nonceStr, // 随机串
                timestamp: parseInt(that.shareConfig.timestamp), // 时间戳
                signature: that.shareConfig.signature // 签名
            });
            // 分享
            wx.ready(function () {
                const url = location.href.split('#')[0];
                var shareData = {
                    title: that.info.title ? that.info.title : that.$publicData.shareDefaultTitleA, // 分享标题
                    desc: that.info.describe, // 分享描述
                    link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: imgUrl ? imgUrl : that.$publicData.domain + that.$publicData.shareDefaultIcon , // 分享图标
                    success: function () {
                        // 用户确认分享后执行的回调函数
                        // alert('成功')
                    },
                    cancel: function (e) {
                        // alert(e)
                        // 用户取消分享后执行的回调函数
                    }
                }
                wx.updateAppMessageShareData(shareData);
                wx.updateTimelineShareData(shareData);
            });
        },
        clickToPublish() {
            if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
                var url = this.$publicData.clientUrl + "/adrift/publish"
                var memberParams = {
                    data: {
                    },
                };
                this.$bridge.callhandler("sdjy://member/memberInfo", memberParams,
                    (data) => {
                        if (data.code == 200) {
                            var params = {
                                data: {
                                    url: url
                                },
                            };
                            this.$bridge.callhandler(
                                "sdjy://public/openNewWebView",
                                params,
                                (data) => {}
                            );
                        } 
                    }
                );
                
            } else {
                if(!this.token){
                    localStorage.setItem('redirect', this.$router.currentRoute.fullPath)
                    this.$router.push({
                        path: '/login',
                    })
                    return
                }else{
                    this.$router.push({
                        path: '/adrift/publish'
                    })
                }
            }
        },
		// 点击分享图标
		clickShareIcon(){
			if(this.info.thumb){
				this.showPosterFun()
			}else{
				return
			}
		}
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.history_comment {
    display: flex;
    flex-direction: row;
    width: 8rem;
    align-items: center;
}
.history_comment_l {
    width: 7rem;
}
.history_comment_r {
    margin-right: .0rem;
}
.page_historyDetail .bottom .icon.back {
    height: 1.46rem;
    justify-content: space-between;
    align-items: center;
    display: flex;
    flex-direction: column;
}
.page_historyDetail .bottom .icons{
    padding-top:.3rem;
}

.page_historyDetail .bottom .icon .title{
    padding:0;
    margin-bottom: 0.2rem;
    font-size: 0.33rem;
    color: #333333;
}

.page_historyDetail .bottom .icon.share img{
	width:0.53rem;
	height:0.53rem;
}
.gifback {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}
.gifimage {
    /* width: 5rem;
    height: 7.575rem; */
	width: 10rem;
	height: auto;
	position: absolute;
	top: 50%;
	left: 0;
	transform: translateY(-50%);
}
/deep/.van-cell {
    padding: 0 .2rem;
    background: transparent;
    color: rgba(0, 0, 0, .54);
    font-size: 0.35rem;
    line-height: normal;
}

/deep/.van-cell .van-field__control {
    color: rgba(0, 0, 0, .54);
    font-size: 0.35rem;
}
</style>
